export const searchFormFields = [
  {
    name: ["search"],
    value: "",
  },
];
